import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const initGSAPEndorphin = () => {

	const scroller = document.querySelector('.endorphin-scroll');

	if (!scroller) return;

	const sentence1 = scroller.querySelector('.endorphin-01');
	const sentence2 = scroller.querySelector('.endorphin-02');
	const sriracha = document.querySelector('.sriracha');

	gsap.set(sentence2, { autoAlpha: 0, yPercent: 100 });
	if (sriracha) {
		gsap.set(sriracha, {
			opacity: 0,
			xPercent: -20,
			yPercent: -20,
			rotate: -5,
		});
	}

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: scroller,
			start: 'top 20%',
			end: '+=1000',
			scrub: 2.5,
			pin: true,
		}
	});

	tl.to(sentence1, {
		yPercent: -10,
		autoAlpha: 0,
	}, '+=1')
	.to(sentence2, {
		yPercent: 0,
		autoAlpha: 1,
	}, ">")
	.to(sriracha, {
		opacity: 1,
		xPercent: 0,
		yPercent: 0,
		duration: 0.8,
		rotate: 0,
		ease: 'power2.inOut',
	},"<") // Only add if sriracha exists
}

export { initGSAPEndorphin };